/* eslint-disable no-undef */
import React from "react";
// import { Divider, Grid } from "@material-ui/core";
// import PropTypes from "prop-types";
// import { Controller, useForm } from "react-hook-form";
// import moment from "moment";
// import Card from "../../../../Card/Card";
// import customIcons from "../../../../utils/icons/icons";
// import colors from "../../../../utils/colors/colors";
// import CustomDatePicker from "../../Pickers/DatePicker";
// import ErrorIndicator from "../../../organisms/ErrorIndicator/ErrorIndicator";
// import CustomDropdown from "../../../../../components/CustomDropdown/Dropdown";
// import IconLabel from "../../IconLabel/iconLabel";
// import { REQUIRED } from "../../../../utils/Constants/ErrorMsg";
import MenuItem from "@material-ui/core/MenuItem";
import FormControl from "@material-ui/core/FormControl";
import Select from "@material-ui/core/Select";
import InputLabel from "@material-ui/core/InputLabel";
import "./TooltipContent.css";
/**
 *
 * @param {object} props - required props in TooltipContent
 * @returns {React.ReactElement} - returns the tooltip content
 */
const TooltipContent = (props) => {
  //   const { contentTitle, onShowOrganization, onCheck } = props;

  //   const {
  //     control,
  //     formState: { errors },
  //   } = useForm({});
  //   const dataList = [
  //     { id: 1, value: "Reason 1" },
  //     { id: 2, value: "Reason 2" },
  //   ];
  //   const EntryData = [
  //     {
  //       Image: customIcons.Calender,
  //       head: "Effective From",
  //       body: "02-02-2022",
  //     },
  //     {
  //       Image: customIcons.Calender,
  //       head: "Effective To",
  //       body: "-",
  //     },
  //   ];
  //   const reason = [
  //     {
  //       Image: customIcons.Content,
  //       head: "Reason",
  //       body: "Quisque suscipit ipsum est, eu venenatis leo ornare ege.",
  //     },
  //   ];
  /**
   *
   */

  /**
   *
   */
  //   const onCancel = () => {
  //     setAddReason(false);
  //   };
  return (
    <div>
      <FormControl className={classes.margin}>
        <InputLabel htmlFor="demo-customized-textbox">Age</InputLabel>
        {/* <BootstrapInput id="demo-customized-textbox" /> */}
      </FormControl>
      <FormControl className={classes.margin}>
        <InputLabel id="demo-customized-select-label">Age</InputLabel>
        <Select
          labelId="demo-customized-select-label"
          id="demo-customized-select"
          value={age}
          onChange={handleChange}
          //   input={<BootstrapInput />}
        >
          <MenuItem value="">
            <em>None</em>
          </MenuItem>
          <MenuItem value={10}>Ten</MenuItem>
          <MenuItem value={20}>Twenty</MenuItem>
          <MenuItem value={30}>Thirty</MenuItem>
        </Select>
      </FormControl>
    </div>
  );
};

export default TooltipContent;
